import {
  Autocomplete,
  Button,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Grid } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AddIcon from "@mui/icons-material/Add";

const AddReceiptsManualInput = () => {
  const companyName = [{ label: "Boyle" }, { label: "Entain" }];

  const currencies = [
    { code: "USD", symbol: "$" },
    { code: "EUR", symbol: "€" },
    { code: "INR", symbol: "₹" },
  ];

  const status = [{ label: "Collected" }, { label: "Partially Collected" }];

  return (
    <>
      <Grid container spacing={2} mb={2} pb={3} sx={{borderBottom:'1px solid #ccc'}}>
        <Grid size={12}>
          <Typography>Receipt #1</Typography>
        </Grid>

        <Grid size={4}>
          <TextField
            label="Receipt Number"
            defaultValue="RC259001039"
            color="secondary"
            placeholder="The transaction serial number "
            fullWidth
            sx={{ mb: 2 }}
            size="small"
          />
          <TextField
            label="Receipt Amount"
            defaultValue="776.8"
            color="secondary"
            placeholder="The sum listed on the receipt"
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <Autocomplete
            sx={{ width: "100%", mb: 2 }}
            options={companyName}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Company"
                placeholder="Who issued this receipt"
                value={""}
                // sx={{ width: "300px" }}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ marginLeft: "12px" }} />
                    </InputAdornment>
                  ),
                }}
                color="secondary"
              />
            )}
            size="small"
          />

          <Autocomplete
            size="small"
            options={currencies}
            getOptionLabel={(option) => option.code}
            renderOption={(props, option) => (
              <li {...props}>
                <span
                  style={{
                    fontSize: "20px",
                    color: "rgba(0, 0, 0, 1)",
                    fontWeight: 500,
                    marginRight: "10px",
                  }}
                >
                  {option.symbol}
                </span>
                {option.code}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Currency"
                color="secondary"
                placeholder="Choose from the list"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <span
                        style={{
                          fontSize: "20px",
                          color: "rgba(0, 0, 0, 1)",
                          fontWeight: 500,
                          marginLeft: "10px",
                        }}
                      >
                        {currencies.find(
                          (c) => c.code === params.inputProps.value
                        )?.symbol || ""}
                      </span>
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid size={4}>
          <Autocomplete
            sx={{ width: "100%", mb: 1 }}
            options={status}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Status"
                placeholder="State of collection"
                value={""}
                // sx={{ width: "300px" }}
                InputProps={{
                  ...params.InputProps,
                }}
                color="secondary"
              />
            )}
            size="small"
          />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker
                slotProps={{
                  textField: {
                    size: "small",
                    color: "secondary",
                    // required: true,
                  },
                }}
                sx={{ width: "100%" }}
                label="Date"
              />
            </DemoContainer>
          </LocalizationProvider>
        </Grid>
      </Grid>


      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Typography>Receipt #2</Typography>
        </Grid>

        <Grid size={4}>
          <TextField
            label="Receipt Number"
            defaultValue="RC259001039"
            color="secondary"
            placeholder="The transaction serial number "
            fullWidth
            sx={{ mb: 2 }}
            size="small"
          />
          <TextField
            label="Receipt Amount"
            defaultValue="776.8"
            color="secondary"
            placeholder="The sum listed on the receipt"
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <Autocomplete
            sx={{ width: "100%", mb: 2 }}
            options={companyName}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Company"
                placeholder="Who issued this receipt"
                value={""}
                // sx={{ width: "300px" }}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ marginLeft: "12px" }} />
                    </InputAdornment>
                  ),
                }}
                color="secondary"
              />
            )}
            size="small"
          />

          <Autocomplete
            size="small"
            options={currencies}
            getOptionLabel={(option) => option.code}
            renderOption={(props, option) => (
              <li {...props}>
                <span
                  style={{
                    fontSize: "20px",
                    color: "rgba(0, 0, 0, 1)",
                    fontWeight: 500,
                    marginRight: "10px",
                  }}
                >
                  {option.symbol}
                </span>
                {option.code}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Currency"
                color="secondary"
                placeholder="Choose from the list"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <span
                        style={{
                          fontSize: "20px",
                          color: "rgba(0, 0, 0, 1)",
                          fontWeight: 500,
                          marginLeft: "10px",
                        }}
                      >
                        {currencies.find(
                          (c) => c.code === params.inputProps.value
                        )?.symbol || ""}
                      </span>
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid size={4}>
          <Autocomplete
            sx={{ width: "100%", mb: 1 }}
            options={status}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Status"
                placeholder="State of collection"
                value={""}
                // sx={{ width: "300px" }}
                InputProps={{
                  ...params.InputProps,
                }}
                color="secondary"
              />
            )}
            size="small"
          />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker
                slotProps={{
                  textField: {
                    size: "small",
                    color: "secondary",
                    // required: true,
                  },
                }}
                sx={{ width: "100%" }}
                label="Date"
              />
            </DemoContainer>
          </LocalizationProvider>
        </Grid>
      </Grid>


      <Grid container spacing={2} mt={3}>
        <Grid size={12}>
          <Button
            variant="outlined"
            size="medium"
            color="secondary"
            endIcon={<AddIcon sx={{ ml: "0.5" }} />}
          >
            Add another
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default AddReceiptsManualInput;
